export const LIST_USERS = "user/getall";
export const CREATE_USER = "user/add";
export const UPDATE_USER = "user/update";
export const GET_USER = (id) => `user/get?id=${id}`;
export const DELETE_USER = (id) => `user/delete?id=${id}`;
export const ACTIVATE_USER = (id) => `user/activate?id=${id}`;

export const LIST_USERS_ACCOUNTING = "user/getallaccounting";
export const LIST_USERS_IMPORT = "user/getallimport";
export const LIST_USERS_PRICING = "user/getallpricing";

export const GET_LOGGED_USER = "user/get";
export const GET_LOGGED_CUSTOMER = "customer/get";

export const CHANGE_PASSWORD = "user/change";
export const RESET_PASSWORD = "user/resetpassword";
